import { RecipeTagsQuery } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getRecipeTags, getRecipeTagsCount } from '../queries/recipe';
import { useAuthStore } from '../stores';

export const RECIPE_TAGS_QUERY_KEY = 'RecipeTags';

export function recipeTagsOptions(
  token: string | null,
  params: RecipeTagsQuery = {
    category: 'food',
  }
) {
  return queryOptions({
    queryKey: [RECIPE_TAGS_QUERY_KEY, params],
    queryFn: () => getRecipeTags(token, params),
    staleTime: 1000 * 60, // 1 minute
  });
}

export function useGetRecipeTags(params?: RecipeTagsQuery) {
  const token = useAuthStore((s) => s.access_token);
  return useQuery(recipeTagsOptions(token, params));
}

function recipeTagsCountOptions(token: string | null) {
  return queryOptions({
    queryKey: [RECIPE_TAGS_QUERY_KEY, 'count'],
    queryFn: () => getRecipeTagsCount(token),
    select(data) {
      return Object.fromEntries(
        data.data.map((value) => [value.category, value.count])
      ) as Record<'all' | 'food' | 'beverage', number>;
    },
  });
}

export function useGetRecipeTagsCount() {
  const token = useAuthStore((s) => s.access_token);
  return useQuery(recipeTagsCountOptions(token));
}
